export default __webpack_public_path__ + "static/media/04.dc4f51eb.jpg";